export default "__VITE_ASSET__MQosmI0x__"